var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { faPlusSquare } from '@fortawesome/pro-light-svg-icons';
import { Icon } from '../../SbGlobal/styles';
import { CardTitle, Container, TitleContainer } from './styles';
import { sbColors as colors } from 'components/UI-helpers/colors';
export var CardWidget = function (_a) {
    var _b;
    var option = _a.option, onClick = _a.onClick;
    var isNew = useMemo(function () { return option.value.includes('new:'); }, [option.value]);
    return (_jsxs(Container, __assign({ centerVr: isNew, onClick: onClick }, { children: [isNew && (_jsxs(_Fragment, { children: [_jsx(Icon, { iconSize: 24, color: colors.default, icon: faPlusSquare }), _jsx(CardTitle, { children: option.label })] })), !isNew && (_jsx(_Fragment, { children: _jsx(TitleContainer, { children: _jsx(CardTitle, { children: (_b = option.label) !== null && _b !== void 0 ? _b : 'Patch' }) }) }))] })));
};
